import { exhaustSwitchCaseElseThrow } from '@stenajs-webui/core';
import type { VehicleType } from '../graphql/fragments/gql/VehicleType';

export function getVehicleTypeDimension(
  vehicleType: VehicleType,
  dimensionName: 'height' | 'length',
) {
  switch (dimensionName) {
    case 'height':
      return vehicleType.defaultHeight;
    case 'length':
      return vehicleType.defaultLength;
    default:
      return exhaustSwitchCaseElseThrow(dimensionName);
  }
}
